module.exports = __webpack_public_path__ + "static/media/wf.a3008b9d.svg";